<script>
	import ContentLink from '$lib/Components/Layout/ContentLink/ContentLink.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import FeaturedCaseStudies from '$lib/PageSections/FeaturedCaseStudies/FeaturedCaseStudies.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import { articles } from './article-data';
</script>

<Section>
	<ul
		class="
    grid list-none grid-cols-1 gap-x-4 gap-y-6
    md:grid-cols-2
  "
	>
		{#each articles as { title, subtitle, href, header, image } (href)}
			<li>
				<ContentLink
					{title}
					{subtitle}
					{href}
					{header}
					{image}
					headingLevel={2}
				/>
			</li>
		{/each}
	</ul>
</Section>
<GetAFreeEstimate />
<FeaturedCaseStudies />
